<template>
  <div class="dashboard-wrap">
    <el-row :gutter="20">
      <el-col class="block" :sm="24" :lg="24">
        <el-card shadow="hover" class="pie-wrap">
          <div style="font-size:14px">
            <el-row>
              <el-col :span="9">
                <div>
                  <span class="demonstration">统计时间:</span>
                  <el-date-picker
                    :clearable="false"
                    style="width:260px"
                    size="mini"
                    v-model="ruleForm.date"
                    value-format="timestamp"
                    type="daterange"
                    placeholder="选择日期范围"
                  ></el-date-picker>
                </div>
              </el-col>
              <el-col :span="5">油卡号:
                <el-input
                  style="width:120px"
                  size="mini"
                  v-model="ruleForm.cardNumber"
                  placeholder="请输入油卡号"
                ></el-input>
              </el-col>
              <el-col :span="5">车牌号:
                <el-input
                  style="width:120px"
                  size="mini"
                  v-model="ruleForm.vehicleNo"
                  placeholder="请输入车牌号"
                ></el-input>
              </el-col>
              <el-col :span="5">油品名称:
                <el-input
                  style="width:120px"
                  size="mini"
                  v-model="ruleForm.oilName"
                  placeholder="请输入油品名称"
                ></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col class="block" :sm="24" :lg="24">
                <el-col :span="6">消费升数下限/L:
                  <el-input
                    style="width:120px"
                    size="mini"
                    type="number"
                    v-model="ruleForm.consumeUnderLine"
                    placeholder="请输入消费下限"
                  ></el-input>
                </el-col>
                <el-col :span="6">消费升数上限/L:
                  <el-input
                    style="width:120px"
                    size="mini"
                    type="number"
                    v-model="ruleForm.consumeUpLine"
                    placeholder="请输入消费上限"
                  ></el-input>
                </el-col>
                <el-col :span="5">卡性质:
                  <el-select
                    style="width:140px"
                    size="mini"
                    v-model="ruleForm.cardType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in cardType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="5">异常类型:
                  <el-select
                    style="width:140px"
                    size="mini"
                    v-model="ruleForm.abnormalType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-col>
            </el-row>
            <el-row class="block" :sm="24" :lg="24">
              <el-col :span="5">油站编码:
                <el-input
                  style="width:120px"
                  size="mini"
                  v-model="ruleForm.nodeno"
                  placeholder="请输入油站编码"
                ></el-input>
              </el-col>
              <el-col :span="2">
                <el-button @click="handleSezarch" size="mini" type="primary">查询</el-button>
              </el-col>
              <el-col :span="2">
                <el-button v-if="hideExport" @click="exportExcel" size="mini" type="primary">导出</el-button>
              </el-col>
              <el-button @click="goBack" style='float:right;' size="mini">返回上级</el-button>
            </el-row>
          </div>
        </el-card>
      </el-col>
      <el-col :sm="24" :lg="24">
        <el-card shadow="hover" class="pie-wrap">
          <div slot="header" class="pie-header">
            <span class>{{areaName}}</span>
          </div>
          <div>
            <template>
              <el-table :data="tableData" border :height="height" style="width: 100%">
                <el-table-column fixed type="index" label='序号' width="50" text-align='center;'></el-table-column>
                <el-table-column prop="cardno" label="卡号" width="150"></el-table-column>
                <el-table-column prop="vehicleNo" label="绑定车牌号" width="120"></el-table-column>
                <el-table-column prop="cardTypeWord" label="卡性质" width="120"></el-table-column>
                <el-table-column prop="userName" label="持卡人" width="120"></el-table-column>
                <el-table-column prop="companyName" label="企业名称" width="120"></el-table-column>
                <el-table-column prop="oiltypeWord" label="油品异常" width="120"></el-table-column>
                <el-table-column prop="oilCountAbnormalWord" label="加油次数异常" width="120"></el-table-column>
                <el-table-column prop="litterAbnormalWord" label="加油量异常" width="120"></el-table-column>
                <el-table-column prop="nodeno" label="消费油站编码" width="120"></el-table-column>
                <el-table-column prop="nodetag" label="消费油站名称" width="120"></el-table-column>
                <el-table-column prop="provName" label="发卡省" width="120"></el-table-column>
                <el-table-column prop="areaName" label="发卡市" width="120"></el-table-column>
                <el-table-column prop="cardSiteNo" label="发卡网点编号" width="120"></el-table-column>
                <el-table-column prop="cardSiteName" label="发卡网点名称" width="120"></el-table-column>
                <el-table-column prop="litter" label="消费升数（升）" width="120">
                  <template slot-scope="scope">
                    {{format(scope.row.litter)}}
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="消费金额（元）" width="120">
                  <template slot-scope="scope">
                    {{format(scope.row.amount)}}
                  </template>
                </el-table-column>
                <el-table-column prop="opetime" label="消费时间" width="120"></el-table-column>
                <el-table-column prop="oilno" label="油品编码" width="120"></el-table-column>
                <el-table-column prop="oilname" label="油品名称" width="120"></el-table-column>
                <el-table-column prop="routeMatch" label="轨迹是否匹配" width="120">
                  <template slot-scope="scope">
                    <template v-if="scope.row.routeMatch==1">正常</template>
                    <template v-if="scope.row.routeMatch==2">异常</template>
                    <template v-if="scope.row.routeMatch==3||scope.row.routeMatch==4">未知</template>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="130" align="center">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.confirmed"
                      @click="isCheck(scope.row.id,scope.row.confirmed)"
                      type="text"
                      size="small"
                    >已核查</el-button>
                    <el-button
                      v-else
                      type="text"
                      size="small"
                      @click="isCheck(scope.row.id,scope.row.confirmed)"
                      style="color:red;"
                    >未核查</el-button>
                    <el-button
                      v-if="scope.row.remark!=null"
                      type="text"
                      size="small"
                      @click="viewNotes(scope.row.remark)"
                    >查看备注</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </div>
        </el-card>
      </el-col>
      <el-col class="block" :sm="24" :lg="24">
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="ruleForm.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="ruleForm.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalPages"
          ></el-pagination>
        </div>
      </el-col>
      
    </el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%">
      <p style="margin-top: -40px;padding-bottom: 20px;    font-size: 14px;font-weight: 650">确认更改状态为 <span style="color:#41B883;" >{{str_title}}</span>  吗？</p>
       <div>
          <textarea v-model="remark" style = 'outline:none;width:100%;height:100px;resize:none; margin: -20px 0;'></textarea>
          <span style = 'text-align: right;display: block;width: 88%;  margin-top: -10px;margin-bottom: -20px; position: absolute;'>{{words}} / 500</span>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modify">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'
import { randomIntegerInRange,hideExport } from '@/utils/tools'
import storage from '@/utils/storage'
// import { getList } from '@/api/dashboard'
import moment from 'moment'

export default {
  name: 'dashboard',
  components: {},
  data() {
    return {
      hideExport:hideExport,
      height: 300,
      totalPages: null,
      currentPage4: 1,
      areaName: this.$route.query.areaName || null,
      seletctDate: this.$route.query.seletctDate || null,
      ruleForm: {
        date: [new Date().getTime() - 2592000000, new Date().getTime()],
        cardNumber: '',
        vehicleNo: '',
        oilName: '',
        consumeUnderLine: '',
        consumeUpLine: '',
        cardType: '',
        abnormalType: '',
        page: 1,
        pageSize: 10,
        nodeno:''
      },
      cardType: [
        {
          value: '',
          label: '不限'
        },
        {
          value: '0',
          label: '单卡'
        },
        {
          value: '1',
          label: '主卡'
        },
        {
          value: '2',
          label: '副卡'
        },
        {
          value: '3',
          label: '未知类型'
        }
      ],
      options: [
        {
          value: '',
          label: '不限'
        },
        {
          value: 'oil',
          label: '油品异常'
        },
        {
          value: 'litter',
          label: '加油量异常'
        },
        {
          value: 'count',
          label: '加油次数异常'
        },
        {
          value: 'route',
          label: '轨迹异常'
        }
      ],
      // pieLegendData: chartData.fpsLegend,
      tableData: [],
      dialogVisible:false,
      str_title:'',
      remark:'',
      words:0,
      modifyId:''
    }
  },
  watch: {
    remark:function(v,o){
        this.words = v.length
        if(this.words>=500){
          this.remark = o;
          this.words = 500;
        }
    }
  },
  mounted() {
    // this.getDate()
    this.getLists()
  },
  created() {
    this.height = window.innerHeight - 400
    window.onresize = () => {
      this.height = window.innerHeight - 400
    }
    this.seletctDate[0] = Number(this.seletctDate[0]);
    this.seletctDate[1] = Number(this.seletctDate[1]);
    if (this.seletctDate) this.ruleForm.date = this.seletctDate
  },
  beforeDestroy() {},
  methods: {
    format(num) {
      var res=num.toString().replace(/\d+/, function(n){ // 先提取整数部分
          return n.replace(/(\d)(?=(\d{3})+$)/g,function($1){
              return $1+",";
            });
      })
      return res;
    },
    goBack() {
      this.$router.go(-1)
    },
    getDate() {
      let date = window.sessionStorage.getItem('date')
      let dates = []
      date = date.split(',').map(ele => {
        dates.push(ele - 0)
      })
      this.ruleForm.date = dates
    },
    handleSezarch() {
      var that = this
      return new Promise(async (resolve, reject) => {
        try {
          this.ruleForm.page = 1
          let areano = that.$route.query.areano
          let syncTimeStart = this.ruleForm.date
            ? new Date(this.ruleForm.date[0]).getTime()
            : ''
          let syncTimeEnd = this.ruleForm.date
            ? new Date(this.ruleForm.date[1]).getTime()
            : ''
          let vehicleNo = this.ruleForm.vehicleNo

          let cardNo = this.ruleForm.cardNumber

          let oilName = this.ruleForm.oilName

          let litterStart = this.ruleForm.consumeUnderLine
          let litterEnd = this.ruleForm.consumeUpLine
          let cardType = this.ruleForm.cardType
          let abnormalType = this.ruleForm.abnormalType

          let page = this.ruleForm.page
          let pageSize = this.ruleForm.pageSize
          let nodeno = this.ruleForm.nodeno

          const response = await this.$store.dispatch('getListData', {
            page,
            pageSize,
            areano,
            syncTimeStart,
            syncTimeEnd,
            vehicleNo,
            cardNo,
            oilName,
            litterStart,
            litterEnd,
            cardType,
            abnormalType,
            nodeno
          })
          if (response.code == 200) {
            this.tableData = response.data.list
            this.totalPages = response.data.count
            response.data &&
              response.data.list.map((ele, index) => {
                if (ele.cardType == 1) {
                  ele.cardTypeWord = '主卡'
                } else if (ele.cardType == 2) {
                  ele.cardTypeWord = '副卡'
                } else if (ele.cardType == 0) {
                  ele.cardTypeWord = '单卡'
                } else {
                  ele.cardTypeWord = '未知'
                }
                ele.routeMatch == 1
                  ? (ele.routeMatchWord = '是')
                  : ele.routeMatch == 2
                  ? (ele.routeMatchWord = '否')
                  : ele.routeMatch == 3
                  ? (ele.routeMatchWord = '未知')
                  : (ele.routeMatchWord = '-')
                ele.opetime
                  ? (ele.opetime = moment(ele.opetime).format(
                      'YYYY-MM-DD HH:mm:ss'
                    ))
                  : (ele.opetime = '-')
                ele.oiltype == 1
                  ? (ele.oiltypeWord = '正常')
                  : ele.oiltype == 2
                  ? (ele.oiltypeWord = '异常')
                  : (ele.oiltypeWord = '未知')
                ele.oilCountAbnormal == 1
                  ? (ele.oilCountAbnormalWord = '正常')
                  : ele.oilCountAbnormal == 2
                  ? (ele.oilCountAbnormalWord = '异常')
                  : (ele.oilCountAbnormalWord = '-')
                ele.litterAbnormal == 1
                  ? (ele.litterAbnormalWord = '正常')
                  : ele.litterAbnormal == 2
                  ? (ele.litterAbnormalWord = '异常')
                  : (ele.litterAbnormalWord = '-')
              })
          }
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    handleExport() {},
    handleClick(row) {},
    handleSizeChange(val) {
      this.ruleForm.pageSize = val
      this.handleSezarch()
    },

    handleCurrentChange(val) {
      var that = this
      return new Promise(async (resolve, reject) => {
        try {
          this.ruleForm.page = val
          let areano = that.$route.query.areano
          let syncTimeStart = this.ruleForm.date
            ? new Date(this.ruleForm.date[0]).getTime()
            : ''
          let syncTimeEnd = this.ruleForm.date
            ? new Date(this.ruleForm.date[1]).getTime()
            : ''
          let cardType = this.ruleForm.cardType
          let vehicleNo = this.ruleForm.vehicleNo
          let cardNo = this.ruleForm.cardNumber
          let oilName = this.ruleForm.oilName
          let litterStart = this.ruleForm.consumeUnderLine
          let litterEnd = this.ruleForm.consumeUpLine
          let abnormalType = this.ruleForm.abnormalType
          let page = this.ruleForm.page
          let pageSize = this.ruleForm.pageSize
          let nodeno = this.ruleForm.nodeno
          const response = await this.$store.dispatch('getListData', {
            page,
            pageSize,
            areano,
            syncTimeStart,
            syncTimeEnd,
            vehicleNo,
            cardNo,
            oilName,
            litterStart,
            litterEnd,
            cardType,
            abnormalType,
            nodeno
          })
          if (response.code == 200) {
            this.tableData = response.data.list
            this.totalPages = response.data.count
            response.data &&
              response.data.list.map((ele, index) => {
                ele.cardType == 0
                  ? (ele.cardTypeWord = '单卡')
                  : (ele.cardTypeWord = '副卡')
                ele.routeMatch == 1
                  ? (ele.routeMatchWord = '是')
                  : ele.routeMatch == 2
                  ? (ele.routeMatchWord = '否')
                  : ele.routeMatch == 3
                  ? (ele.routeMatchWord = '未知')
                  : (ele.routeMatchWord = '-')
                ele.opetime
                  ? (ele.opetime = moment(ele.opetime).format(
                      'YYYY-MM-DD HH:mm:ss'
                    ))
                  : (ele.opetime = '-')
                ele.oiltype == 1
                  ? (ele.oiltypeWord = '正常')
                  : ele.oiltype == 2
                  ? (ele.oiltypeWord = '异常')
                  : (ele.oiltypeWord = '未知')
                ele.oilCountAbnormal == 1
                  ? (ele.oilCountAbnormalWord = '正常')
                  : ele.oilCountAbnormal == 2
                  ? (ele.oilCountAbnormalWord = '异常')
                  : (ele.oilCountAbnormalWord = '-')
                ele.litterAbnormal == 1
                  ? (ele.litterAbnormalWord = '正常')
                  : ele.litterAbnormal == 2
                  ? (ele.litterAbnormalWord = '异常')
                  : (ele.litterAbnormalWord = '-')
              })
          }
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    getLists() {
      var that = this
      return new Promise(async (resolve, reject) => {
        try {
          let areano = that.$route.query.areano
          let syncTimeStart = that.ruleForm.date
            ? new Date(Number(that.ruleForm.date[0])).getTime()
            : ''
          let syncTimeEnd = that.ruleForm.date
            ? new Date(Number(that.ruleForm.date[1])).getTime()
            : ''
          let page = that.ruleForm.page
          let pageSize = that.ruleForm.pageSize
          const response = await that.$store.dispatch('getListData', {
            page,
            pageSize,
            areano,
            syncTimeStart,
            syncTimeEnd
          })
          if (response.code == 200) {
            that.tableData = response.data.list
            that.totalPages = response.data.count
            response.data &&
              response.data.list.map((ele, index) => {
                ele.cardType == 0
                  ? (ele.cardTypeWord = '单卡')
                  : ele.cardType == 1
                  ? (ele.cardTypeWord = '主卡')
                  : ele.cardType == 2
                  ? (ele.cardTypeWord = '副卡')
                  : (ele.cardTypeWord = '未知')
                ele.routeMatch == 1
                  ? (ele.routeMatchWord = '是')
                  : ele.routeMatch == 2
                  ? (ele.routeMatchWord = '否')
                  : ele.routeMatch == 3
                  ? (ele.routeMatchWord = '未知')
                  : (ele.routeMatchWord = '-')
                ele.opetime
                  ? (ele.opetime = moment(ele.opetime).format(
                      'YYYY-MM-DD HH:mm:ss'
                    ))
                  : (ele.opetime = '-')
                ele.oiltype == 1
                  ? (ele.oiltypeWord = '正常')
                  : ele.oiltype == 2
                  ? (ele.oiltypeWord = '异常')
                  : (ele.oiltypeWord = '未知')
                ele.oilCountAbnormal == 1
                  ? (ele.oilCountAbnormalWord = '正常')
                  : ele.oilCountAbnormal == 2
                  ? (ele.oilCountAbnormalWord = '异常')
                  : (ele.oilCountAbnormalWord = '-')
                ele.litterAbnormal == 1
                  ? (ele.litterAbnormalWord = '正常')
                  : ele.litterAbnormal == 2
                  ? (ele.litterAbnormalWord = '异常')
                  : (ele.litterAbnormalWord = '-')
              })
          }
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    exportExcel() {
      let that = this

      let areano = that.$route.query.areano
      let syncTimeStart = this.ruleForm.date
        ? new Date(this.ruleForm.date[0]).getTime()
        : ''
      let syncTimeEnd = this.ruleForm.date
        ? new Date(this.ruleForm.date[1]).getTime()
        : ''
      let cardType = this.ruleForm.cardType
      let vehicleNo = this.ruleForm.vehicleNo
      let cardNo = this.ruleForm.cardNumber
      let oilName = this.ruleForm.oilName
      let litterStart = this.ruleForm.consumeUnderLine
      let litterEnd = this.ruleForm.consumeUpLine
      let abnormalType = this.ruleForm.abnormalType
      let nodeno = this.ruleForm.nodeno
      let data = {
        areano,
        syncTimeStart,
        syncTimeEnd,
        cardType,
        vehicleNo,
        cardNo,
        oilName,
        litterStart,
        litterEnd,
        abnormalType,
        nodeno
      }
      window.location.href =
        '/bi-api/abnormal/exportAbnormalList?areano=' +
        areano +
        '&syncTimeStart=' +
        syncTimeStart +
        '&syncTimeEnd=' +
        syncTimeEnd +
        '&cardType=' +
        cardType +
        '&vehicleNo=' +
        vehicleNo +
        '&cardNo=' +
        cardNo +
        '&oilName=' +
        oilName +
        '&litterStart=' +
        litterStart +
        '&litterEnd=' +
        litterEnd +
        '&abnormalType=' +
        abnormalType
    },
    isCheck(id, confirm) {
      this.dialogVisible = true
      this.modifyId = id
      this.remark = ''
      this.str_title = confirm ? '未核查' : '已核查'
      // if(confirm){
          // this.$prompt('确认更改状态为' + str + '吗？',  {
          // confirmButtonText: '确定',
          // cancelButtonText: '取消',
          // this.$msgbox({
          // title: '确认更改状态为' + str + '吗？',
          // message: h('div',  null, [
          //   h('textarea', {style:'witdh:290px;hieght:90px;resize:none;'}, ''),
          //   h('span', { style: ' text-align: right;display: block;width: 100%;  margin-top: -20px; padding-right: 6px;' }, '0 / 500')
          // ]),
        // this.$alert(`
        //       <div>
        //         <textarea style = 'width:100%;height:90px;resize:none;'></textarea>
        //         <span style = 'text-align: right;display: block;width: 100%;  margin-top: -20px; padding-right: 6px;'>0 / 500</span>
        //       </div>
        //   `, '确认更改状态为' + str + '吗？', {
        //     dangerouslyUseHTMLString: true,
        //     showCancelButton: true,
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        // }).then(_ => {
        //     axios
        //       .get('/bi-api/abnormal/setAbnormalConfirmed?id=' + id)
        //       .then(e => {
        //         if (e.code == 200) {
        //           that.handleSezarch()
        //         }
        //       })
        //     done()
        //   })
        //   .catch(_ => {})
      // }
      
    },
    modify(){
      let that = this;
      axios.get('/bi-api/abnormal/setAbnormalConfirmed?id=' + this.modifyId +'&remark='+encodeURIComponent(this.remark))
        .then(e => {
          this.dialogVisible = false
          if (e.code == 200) {
            that.handleSezarch()
          }
        })
    },
    viewNotes(a){
      this.$alert(a, '备注信息', {
          confirmButtonText: '确定',
        });
    }
  }
}
</script>

<style lang="stylus" scoped>
.el-dialog__body{
  padding:10px 20px !important;
}
.el-main {
  positon: relative;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

box-style(bg) {
  width: 100%;
  height: 130px;
  background: white;
  display: flex;
  margin-top: 15px;

  .leftPart {
    background: bg;
    width: 130px;
    @extend .flex-center;
  }

  .rightPart {
    flex: 1;
    color: #99a9c0;
    @extend .flex-center;
    flex-direction: column;

    .number {
      font-size: 30px;
      padding-bottom: 6px;
    }

    .font-center {
      text-align: center;
    }
  }
}

.dashboard-row {
  width: 100%;
  height: 400px;
  margin-top: 15px;
  background: white;
}

.dashboard-wrap {
  margin-top: -40px;

  .box1 {
    box-style(#41b883);
  }

  .box2 {
    box-style(#9ab7e0);
  }

  .box3 {
    box-style(#f7c94d);
  }

  .box4 {
    box-style(#e45f5f);
  }

  .block {
    margin-top: 20px;

    .pagination {
      text-align: center;
      position: fixed;
      bottom: 4px;
      background: #f1f2f7;
      width :90%;
      padding-top :10px;
    }
  }

  .line-chart {
    @extend .dashboard-row;
    padding: 15px;
    box-sizing: border-box;
  }

  .todo-wrap {
    @extend .dashboard-row;

    .todo-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }

      .enterTodo {
        float: right;
        width: 140px;
        position: relative;
        top: -8px;
        right: -11px;
      }
    }

    .todo-list {
      div:not(:first-child) {
        margin-top: 15px;
      }
    }
  }

  .system-report {
    @extend .dashboard-row;
    height: 520px;

    .report-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }
    }

    .report-content {
      .el-alert:not(:first-child) {
        margin-top: 15px;
      }

      .progress-wrap {
        margin-top: 20px;
        text-align: center;
        padding: 20px;

        .el-progress:not(:first-child) {
          margin-left: 20px;
        }
      }
    }
  }

  .pie-wrap {
    @extend .dashboard-row;
    height: 100%;

    .pie-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }
    }
  }
}
</style>
